export const setConditions = (conditions) => async (dispatch, getState) => {
    dispatch({ type: 'SET_CONDITIONS', data: conditions });
    return Promise.resolve();
};

export const setFurnitureTypes = (furnitureTypes) => async (dispatch, getState) => {
    dispatch({ type: 'SET_FURNITURE_TYPES', data: furnitureTypes });
    return Promise.resolve();
};